import { Show, type JSX } from 'solid-js'

import Css from './ui.module.scss'

/**
 * O campo de data do painel.
 *
 * Um so, porque QUATRO telas escolhem data - o painel, a ficha do paciente, a base
 * de usuarios e o relatorio de sono - e ate aqui cada uma tinha a sua copia das
 * mesmas classes. Copia de estilo e o jeito de duas telas divergirem sem ninguem
 * decidir que deviam divergir.
 *
 * `onDark` e a forma de vidro, usada dentro das faixas escuras de filtro; sem ele o
 * campo e a caixa branca com borda dos formularios. O `[color-scheme:dark]` nao e
 * enfeite: sem ele o navegador desenha o icone de calendario preto sobre o fundo
 * escuro, e ele some.
 */
export function DateField(props: {
    value: string
    onChange: (value: string) => void
    /** Nomeia o campo SEMPRE, como `aria-label`; e visivel se `hideLabel` for falso. */
    label: string
    min?: string
    max?: string
    onDark?: boolean
    /**
     * Esconde o rotulo, mantendo o nome acessivel.
     *
     * Para as linhas onde os campos ficam em sequencia com uma palavra no meio
     * ("de X ate Y"): ali o rotulo acima quebraria a leitura da frase, mas o campo
     * continua precisando de nome para quem usa leitor de tela.
     */
    hideLabel?: boolean
    class?: string
}): JSX.Element {
    /*
        A largura pedida vai para o elemento de FORA em cada forma: no campo quando
        ele esta solto, e no rotulo quando ha rotulo. Deixar `w-full` fixo no input e
        somar a classe do chamador nao funciona - as duas sao utilitarios de largura,
        quem vence e a ordem em que o Tailwind as emite, e `w-full` ganhava: o campo
        de data do painel esticava para a linha inteira e quebrava para baixo.
    */
    const field = (
        <input
            type="date"
            value={props.value}
            min={props.min}
            max={props.max}
            aria-label={props.label}
            onInput={(event) => props.onChange(event.currentTarget.value)}
            class={`${Css.date} ${props.hideLabel ? (props.class ?? '') : Css.dateWide}`}
            classList={{ [Css.onDark]: props.onDark }}
        />
    )

    return (
        <Show when={!props.hideLabel} fallback={field}>
            <label class={`${Css.labelledField} ${props.class ?? ''}`}>
                <span class={Css.fieldLabel} classList={{ [Css.onDark]: props.onDark }}>
                    {props.label}
                </span>
                {field}
            </label>
        </Show>
    )
}
